import React, { Fragment } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import SubunitContent from 'chameleon/ui-stack/ui/units/subunit-content';
import { mapAssignmentsToResourceIds } from 'chameleon/ui-stack/ui/units/utils';
import {
  TeacherProgressChecks,
  StudentProgressChecks,
} from '../../subunit-content/ppc';
import {
  TeacherPracticeProblems,
  StudentPracticeProblems,
} from '../../subunit-content/spp';
import { setVisitedSubunitsAction } from '../state/actions';
import getIsExpanded from '../utils/getIsExpanded';

const RowWrapper = (props) => {
  const {
    subunitId,
    subunitRefs,
    visitedSubunits,
    setVisitedSubunits,
    subjectId,
    userId,
    item,
    TableRow,
    TableColumns,
    isPPC,
    isPE,
    isSPP,
    isLC,
    isPT,
    unitData,
    useClassroomResourceAddress,
    widgetTagColumn,
    unitsLabel,
    userData,
    assignAllVideos,
    subjectData,
    subunitLabel,
    hasResources,
    teacherAssignments = {},
    apSourcesFlag,
  } = props;

  const { isStudent } = userData;
  const {
    number: unitNumber,
    title: unitTitle,
    unitId,
    displayName: unitDisplayName,
  } = unitData;
  const { cells, original } = item;
  const { number, resources, displayName, metadata, iconName, type } = original;
  /**
   * Number is not available for unit 0 and -1, we use subunitId
   * */
  const expanderId = number || subunitId;
  const showProgressCheckComps = isPPC || isPE || isLC || isPT;
  const commonProps = {
    useClassroomResourceAddress,
    unitId,
    unitNumber,
    subunitNumber: number,
    unitTitle,
    subunitTitle: displayName,
    iconName,
    widgetTagColumn,
    unitsLabel,
    resources,
    metadata,
    userData,
    subjectData,
    assignAllVideos,
    subunitLabel,
    unitDisplayName,
    type,
    apSourcesFlag,
  };
  const expandedContent = `expanded-content-${subunitId}`;

  const onRowClick = ({ number, isExpanded }) => {
    setVisitedSubunits({
      subjectId,
      userId,
      unitNumber,
      number,
      isVisited: !isExpanded,
    });
  };

  const isExpanded = getIsExpanded({
    visitedSubunits,
    key: [`${subjectId}-${userId}`, unitNumber],
    unitNumber,
    expanderId,
  });

  return (
    <Fragment>
      <TableRow
        ref={(el) => (subunitRefs.current[expanderId] = el)}
        onClick={() => {
          onRowClick({
            number: expanderId,
            isExpanded,
          });
        }}
        className={cn({
          'bg-blue-100': isExpanded,
        })}
        row={item}
        key={`tr-${expanderId}`}
        tabIndex={0}
        aria-controls={expandedContent}
        aria-expanded={isExpanded}
      >
        <TableColumns cells={cells} lastItemClassName="pr-4" />
      </TableRow>
      {isExpanded && hasResources && (
        <tr id={expandedContent} key={expandedContent}>
          <td colSpan={cells.length}>
            {(!isStudent && showProgressCheckComps && (
              <TeacherProgressChecks
                assignments={mapAssignmentsToResourceIds(
                  teacherAssignments,
                  resources,
                )}
                {...commonProps}
              />
            )) ||
              (isStudent && showProgressCheckComps && (
                <StudentProgressChecks
                  unitId={unitId}
                  resources={resources}
                  unitDisplayName={unitDisplayName}
                  subunitType={type}
                />
              )) ||
              (!isStudent && isSPP && (
                <TeacherPracticeProblems
                  assignments={mapAssignmentsToResourceIds(
                    teacherAssignments,
                    resources,
                  )}
                  {...commonProps}
                />
              )) ||
              (isStudent && isSPP && (
                <StudentPracticeProblems
                  unitId={unitId}
                  resources={resources}
                />
              )) || <SubunitContent {...commonProps} />}
          </td>
        </tr>
      )}
    </Fragment>
  );
};

RowWrapper.propTypes = {};

const mapStateToProps = ({
  subject,
  featureFlag,
  userData,
  visitedSubunits,
}) => {
  const {
    data: { isPreApSubject },
  } = subject;
  return {
    visitedSubunits,
    userData,
    subjectData: subject.data,
    assignAllVideos: featureFlag.assign_all_videos,
    useClassroomResourceAddress:
      !!isPreApSubject && !!featureFlag.preap_outline_use_resources_route,
    apSourcesFlag: featureFlag.ap_sources,
  };
};

export default connect(mapStateToProps, {
  setVisitedSubunits: setVisitedSubunitsAction,
})(RowWrapper);
